import { signup } from 'util/api'
import { useDocTitle } from 'util/hooks'

import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import 'css/pages/signup.css'
import { showToast } from 'components/toast'

export const Signup = () => {
	const navigate = useNavigate()

	const [ firstName, setFirstName ] = useState()
	const [ lastName, setLastName ] = useState()
	const [ email, setEmail ] = useState()
	const [ password, setPassword ] = useState()

	const onPasswordBlur = ({ target }) => {
		const conditions = [
			/.{8,}/,
			/[0-9]+/,
			/[a-z]+/,
			/[A-Z]+/,
			/[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]+/,
		]

		setPassword(target.value)

		if (
			conditions.every(pattern => target.value.match(pattern))
		) {
			target.setCustomValidity('')
			return
		}
		
		target.setCustomValidity(
			'The password must be at least 8 characters long and must use a lower case character, an upper case character, a number, and a special character.'
		)
	}

	const onConfirmPasswordBlur = ({ target }) => {
		if (
			target.value === password
		) {
			target.setCustomValidity('')
			return
		}

		target.setCustomValidity(
			'This does not match the password entered above'
		)
	}

	const onFormSubmit = async e => {
		e.preventDefault()

		let response
		try {
			response = await signup(
				firstName,
				lastName,
				email,
				password,
			)
		} catch (err) {
			showToast("We couldn't reach the server. Check your internet connection and try again.")
			return
		}

		// EH-17: the server answers identically whether or not the email already
		// has an account (no enumeration), so there is no 'already exists' branch
		// here. The verification page states the neutral case and offers Log in.
		if (response.status === 200) {
			navigate(`/verification?email=${email}`)
			return
		}

		showToast("Something went wrong. Please try again.")
	}

	useDocTitle('All for One - Sign up')

	return (
		<section className="signup-container">
			<h1 className="signup-header">Let’s <span className="highlight">sign you up!</span></h1>

			<form
				id="signup-form"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
				<div className="form-group">
					<label htmlFor="first-name" className="visually-hidden"></label>
					<input 
						type="text" 
						id="first-name" 
						name="first-name" 
						placeholder="First Name" 
						required
						onChange={({ target }) => setFirstName(target.value)}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="last-name" className="visually-hidden"></label>
					<input 
						type="text" 
						id="last-name" 
						name="last-name" 
						placeholder="Last Name" 
						required
						onChange={({ target }) => setLastName(target.value)}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="email" className="visually-hidden"></label>
					<input 
						type="email" 
						id="email" 
						name="email" 
						placeholder="Email" 
						required
						onChange={({ target }) => setEmail(target.value)}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="password" className="visually-hidden"></label>
					<input 
						type="password" 
						id="password" 
						name="password" 
						placeholder="Password" 
						required
						onBlur={onPasswordBlur}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="confirm-password" className="visually-hidden"></label>
					<input 
						type="password" 
						id="confirm-password" 
						name="confirm-password" 
						placeholder="Confirm Password" 
						required
						onBlur={onConfirmPasswordBlur}
					/>
				</div>

				<div className="form-group">
					<button type="submit" className="signup-btn">Sign up</button>
				</div>
			</form>

			<p className="login-prompt">
				Already have an account? <Link to="/login" className="login-link">Log in!</Link>
			</p>
		</section>
	)
}
